/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';
import UserMessages from 'app/modules/UserMessageModule.js';

export const posts = (state = defaultState.posts, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        posts = [];

    // reset post preview when social show or route show is called
    if (action.status === constants.STATE_TXRX) {
        switch (action.type) {
            case constants.ROUTE_SHOW:
            case constants.INPUT_SHOW:
            case constants.SOCIAL_SHOW:
                nextState.preview = null;
                break;

            default:
                break;
        }
    }

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.POST_CREATE:
            case constants.POST_CREATE_OLD:
                ++nextState.created;
                break;

            case constants.POST_SHOW:
                nextState.post = action.payload;
                break;

            case constants.POST_UPLOAD:
                ++nextState.updated;
                break;

            case constants.POST_PREVIEW:
                nextState.preview = action.payload;
                break;

            case constants.POST_VALIDATORS_LIST:
                nextState.postValidators = action.payload;
                break;

            case constants.POST_MEDIA_VALIDATION:
                if (Object.keys(action.payload).length) {
                    Object.keys(action.payload).map((key) => {
                        if (action.payload[key].validation === '' && nextState.mediaValidation[key] !== undefined) {
                            delete nextState.mediaValidation[key];
                        } else {
                            nextState.mediaValidation[key] = action.payload[key];
                        }
                    })
                }
                break;

            case constants.POST_MEDIA_GALLERY:
                if (action.payload.page === null || action.payload.page === 1) {
                    nextState.mediaGallery.media = action.payload.photos;
                } else if (action.payload.page > 1) {
                    nextState.mediaGallery.media = nextState.mediaGallery.media.concat(action.payload.photos);
                }
                nextState.mediaGallery.page = (action.payload.page === null) ? 1 : action.payload.page;
                break;

            default:
                break;

        }
    }

    return nextState;
};
